import React, { useContext, useEffect, useState } from 'react';
import './App.css';
import './fonts/Lato-Black.ttf';
import './fonts/Lato-BlackItalic.ttf';
import './fonts/Lato-Bold.ttf';
import './fonts/Lato-Italic.ttf';
import './fonts/Lato-Light.ttf';
import './fonts/Lato-LightItalic.ttf';
import './fonts/Lato-Regular.ttf';
import './fonts/Lato-Thin.ttf';
import './fonts/Lato-ThinItalic.ttf';
import { REFERRAL_ID_KEY, STORAGE_USER_ID_KEY } from './services/Constant';
import SignInComponent from './pages/SignInComponent';
import {
  ACTIVITY_APPROVAL_OVERVIEW_SHEET_ROUTE_NAME,
  ACTIVITY_APPROVAL_SHEET_ROUTE_NAME,
  ApplicationRoute,
  CLIENTS_DASHBOARD_ROUTE_NAME,
  EDIT_EMPLOYEE_ROUTE_NAME,
  EMPLOYEE_DASHBOARD_ROUTE_NAME,
  EMPLOYEES_ROUTE_NAME,
  FACESHEET,
  PROGRESS_NOTE_SETUP,
} from './routes/Routing';
import { EventBusProvider } from './context/EventBusProvider';
import SnackBarComponent from './components/formlib/SnackBarComponent';
import { ReactComponent as SessionIcon } from './assets/images/expiryIcon.svg';
import { ResponseType } from './utils/type';
import ScrollToTop from './ScrollToTop';
import { useNavigate } from 'react-router';
import { getFaceSheetSideBarManus, getSideBarMenus } from './layouts/Sidebar';
import { LookUpContext } from './context/LookUpContextProvider';
import { Context, ContextType } from './LanguageWrapper';
import { clearClientStorageDetails, saveCurrentTime } from './utils/utilities';
import { UnSavedChangesContext } from './context/UnSavedChangesProvider';
import AuthScreen from './pages/AuthScreen';
import { useAppDispatch } from './redux/hooks';
import { resetReviewActivitySheetFilter } from './redux/features/reviewActivitySheet/reviewActivitySheetFilterSlice';
import { resetClientListFilters } from './redux/features/clientList/clientListFilterSlice';
import { persistor } from './redux/store';
import { resetEmployeeListFilter } from './redux/features/employeeList/employeeListFilterSlice';

function App() {
  const [userLoggedIn, setUserLoggedIn] = useState<string | null>();
  const [showMessage, setShowMessage] = useState<boolean>(false);
  const [successOrError, setSuccessOrError] = useState<ResponseType>('success');

  const navigation = useNavigate();

  const { updateDemographics, updateNotificationAndProfileEnabled } =
    React.useContext(LookUpContext);

  const context: ContextType = useContext(Context);
  const { hasUnsavedChanges } = useContext(UnSavedChangesContext);

  useEffect(() => {
       context.selectLanguage();
  }, []);

  useEffect(() => {
    const lookupsDemographics = localStorage.getItem('Demographics');
    if (lookupsDemographics) {
      updateDemographics(JSON.parse(lookupsDemographics));
    }
  }, []);

  // Handle beforeunload event
  useEffect(() => {
    const currentUrl = document.location.pathname;
    const subMenuMatched = getFaceSheetSideBarManus().find((subMenu) =>
      currentUrl.includes(subMenu.to),
    );

    const handleBeforeUnload = (event: BeforeUnloadEvent) => {
      if (!subMenuMatched?.hasGoogleTranslation && hasUnsavedChanges) {
        event.preventDefault();
      }
    };

    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [hasUnsavedChanges]);

  useEffect(() => {
    const disableBackButton = (event: PopStateEvent) => {
      const currentUrl = document.location.pathname;

      const getReferralId = localStorage.getItem(REFERRAL_ID_KEY);

      if (getReferralId === null || currentUrl === FACESHEET) {
        if (
          getSideBarMenus().some((menu) => {
            if (menu.to.includes(currentUrl) || currentUrl === FACESHEET) {
              return true;
            }
            // Check if the submenu contains the current URL
            if (menu.subMenus && menu.subMenus.length > 0) {
              return menu.subMenus.some((subMenu) =>
                subMenu.to.includes(currentUrl),
              );
            }
            return false;
          })
        ) {
          if (
            currentUrl !== EMPLOYEE_DASHBOARD_ROUTE_NAME &&
            currentUrl !== ACTIVITY_APPROVAL_OVERVIEW_SHEET_ROUTE_NAME
          ) {
            navigation(EMPLOYEE_DASHBOARD_ROUTE_NAME);
            event.preventDefault();
            event.stopPropagation();
          }
        }
      } else {
        const subMenuMatched = getFaceSheetSideBarManus().find(
          (subMenu) =>
            currentUrl.includes(subMenu.to) ||
            currentUrl.includes(subMenu.to.concat('#')),
        );

        if (subMenuMatched?.hasGoogleTranslation) {
                    event.preventDefault();
          event.stopPropagation();
          return;
        } else {
          navigation(FACESHEET);
          event.preventDefault();
          event.stopPropagation();
        }
      }
    };

    // Add an event listener to continuously disable the back button
    window.addEventListener('popstate', disableBackButton);

    const currentUrlPath = document.location.pathname;

    const shouldClearStorage = getSideBarMenus().some((menu) => {
      if (menu.to === currentUrlPath) {
        return true;
      }

      if (menu.subMenus && menu.subMenus.length > 0) {
        return menu.subMenus.some((subMenu) =>
          subMenu.to.includes(currentUrlPath),
        );
      }

      return false;
    });

    if (shouldClearStorage) {
      sessionStorage.clear();
      clearClientStorageDetails();
    }
    window.addEventListener('storage', function (e) {
      if (e.key === 'clientReferralDetails') {
        if (
          localStorage.getItem(REFERRAL_ID_KEY) === null &&
          localStorage.getItem(STORAGE_USER_ID_KEY) !== null
        ) {
          navigation(EMPLOYEE_DASHBOARD_ROUTE_NAME);
        } else if (
          localStorage.getItem(REFERRAL_ID_KEY) !== null &&
          localStorage.getItem(STORAGE_USER_ID_KEY) !== null
        ) {
          navigation(FACESHEET);
        }
      }

      if (e.key === 'selectedProgram') {
        if (localStorage.getItem(STORAGE_USER_ID_KEY) !== null) {
          navigation(EMPLOYEE_DASHBOARD_ROUTE_NAME);
                    window.location.reload();
        }
      }

      if (!e.newValue) {
        if (localStorage.getItem(STORAGE_USER_ID_KEY) === null) {
                    window.location.reload();
        }
      }
    });
    // Clean up the event listener when the component unmounts
    return () => {
      window.removeEventListener('popstate', disableBackButton);
    };
  }, []);

  const dispatch = useAppDispatch();
  useEffect(() => {
    const clientId = localStorage.getItem('ClientId');
    const currentUrl = document.location.pathname;
    if (!clientId && currentUrl !== CLIENTS_DASHBOARD_ROUTE_NAME) {
      dispatch(resetClientListFilters());
      // Clear persisted storage
      persistor.purge();
    }
    if (
      currentUrl !== ACTIVITY_APPROVAL_OVERVIEW_SHEET_ROUTE_NAME &&
      currentUrl !== ACTIVITY_APPROVAL_SHEET_ROUTE_NAME &&
      currentUrl !== PROGRESS_NOTE_SETUP
    ) {
      dispatch(resetReviewActivitySheetFilter());
    }

    if (
      currentUrl !== EDIT_EMPLOYEE_ROUTE_NAME &&
      currentUrl !== EMPLOYEES_ROUTE_NAME
    ) {
      dispatch(resetEmployeeListFilter());
    }
  }, [document.location.pathname]);

  const getExceptionMessage = () => {
    const itsLoginIssue = localStorage.getItem('itsLoginIssue');
    const permissionFlag = localStorage.getItem('permissionDenied');

    if (itsLoginIssue && itsLoginIssue === 'true') {
      return 'session.itsLoginIssueMessage';
    } else if (permissionFlag) {
      return 'permissionDeniedMessage';
    } else {
      return 'sessionExpiryMessage';
    }
  };

  useEffect(() => {
    window.process = {
      ...window.process,
    };

    const selectedProgram = localStorage.getItem('selectedProgram');

    if (selectedProgram) {
      const permissionOfThisProgram = localStorage.getItem(
        JSON.parse(selectedProgram).id,
      );
      if (permissionOfThisProgram) {
        updateNotificationAndProfileEnabled(true);
      }
    }

    EventBusProvider.subscribe('logout', () => {
      setSuccessOrError('error');
      setShowMessage(true);
      setUserLoggedIn(null);
      // after 2 seconds navigate to login
      setTimeout(() => {
        sessionStorage.clear();
        // read webAppBuildNumber from localstorage and set it again after clearing the localstorage
        const webAppBuildNumber = localStorage.getItem('webAppBuildNumber');
        localStorage.clear();
        if (webAppBuildNumber) {
          localStorage.setItem('webAppBuildNumber', webAppBuildNumber);
        }
        setShowMessage(false);
        navigation('/');
      }, 3000);
    });
    setUserLoggedIn(localStorage.getItem(STORAGE_USER_ID_KEY));
  }, []);

  if (userLoggedIn === undefined) {
    return null;
  }

  const pathname = window.location.pathname;
    if (pathname === '/auth') {
    return (
      <>
        {showMessage && (
          <SnackBarComponent
            open={showMessage}
            handleClose={() => {
              setShowMessage(false);
            }}
            icon={<SessionIcon />}
            successOrError={successOrError}
            labelId={getExceptionMessage()}
          />
        )}
        <AuthScreen
          onLoginSuccess={(userId) => {
            saveCurrentTime();
            setUserLoggedIn(userId);
          }}
        />
      </>
    );
  } else if (userLoggedIn === null) {
    const permissionFlag = localStorage.getItem('permissionDenied');
    return (
      <>
        {showMessage && (
          <SnackBarComponent
            open={showMessage}
            handleClose={() => {
              setShowMessage(false);
            }}
            icon={<SessionIcon />}
            successOrError={successOrError}
            labelId={
              permissionFlag
                ? 'permissionDeniedMessage'
                : 'sessionExpiryMessage'
            }
          />
        )}
        <SignInComponent
          onLoginSuccess={(userId) => {
            setUserLoggedIn(userId);
          }}
        />
      </>
    );
  } else {
    return (
      <>
        <ScrollToTop />
        <ApplicationRoute
          onLogout={() => {
            setUserLoggedIn(null);
          }}
        />
      </>
    );
  }
}

export default App;
